import type { TextMaterialTheme, TextMaterialThemeTranslation, UpdateTextMaterialThemeInput } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'
import { TEXT_CATEGORY } from '@hive/status'

import { mergeLeft } from 'merge-left-utils'


export interface TextMaterialThemeFormState {
  id?: GQL_ID
  name?: string
  title: string
  slug?: string
  status: string
  parend_id?: GQL_ID
  activeFrom?: Date
  activeUntil?: Date
  priority_weight?: number
  languages: string[]
  i18n: TextMaterialThemeTranslation[]
}

export const TEXT_MATERIAL_CATEGORY_DEFAULT_STATE: TextMaterialThemeFormState = {
  id: undefined,
  name: '',
  title: '',
  slug: '',
  status: TEXT_CATEGORY.DISABLED,
  parend_id: undefined,
  activeFrom: undefined,
  activeUntil: undefined,
  priority_weight: 0,
  languages: [ 'ru', 'kk' ],
  i18n: []
}

export const makeTextMaterialThemeFormState = (
  textMaterialTheme?: TextMaterialTheme
): TextMaterialThemeFormState => {
  const activeLanguages = textMaterialTheme?.i18n?.map(({ languageCode }) => languageCode) || [ 'ru', 'kk' ]
  return mergeLeft<TextMaterialThemeFormState>(TEXT_MATERIAL_CATEGORY_DEFAULT_STATE, {
    ...textMaterialTheme,
    languages: activeLanguages,
    activeFrom: textMaterialTheme?.activeFrom ? new Date(textMaterialTheme.activeFrom) : undefined,
    activeUntil: textMaterialTheme?.activeUntil ? new Date(textMaterialTheme.activeUntil) : undefined
  })
}

export const mapStateToApiVariable = (state: TextMaterialThemeFormState): UpdateTextMaterialThemeInput => {
  const { languages, ...rest } = state
  
  return {
    ...rest,
    activeFrom: state.activeFrom?.getTime(), 
    activeUntil: state.activeUntil?.getTime(),
    priority_weight: Number(state.priority_weight) || 0,
  }
}

export const mapApiDataToState = (data: TextMaterialTheme): TextMaterialThemeFormState => {
  const activeLanguages = data?.i18n.map(({ languageCode }) => languageCode) || [ 'ru', 'kk' ]
  
  return {
    ...data,
    i18n: data?.i18n ? data.i18n.map(({ languageCode, title }) => ({
      languageCode,
      title
    })) : activeLanguages.map((languageCode) => ({
      languageCode,
      title: '',
      content: '',
      lead: ''
    })),
    languages: data.i18n?.length > 0 ? data.i18n.map(({ languageCode }) => languageCode) : [ 'ru', 'kk' ],
    activeFrom: data.activeFrom ? new Date(data.activeFrom) : undefined,
    activeUntil: data.activeUntil ? new Date(data.activeUntil) : undefined
  }
}
